import React, { useState } from 'react';
import { Menu, X, Phone, MapPin, Sparkles } from 'lucide-react';
import ProtectedContact, { ENCODED_CONTACTS } from './ProtectedContact';

export default function Navbar({ activeTab, setActiveTab }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navItems = [
    { id: 'home', labelZh: '首頁', labelEn: 'Home' },
    { id: 'about', labelZh: '關於我們', labelEn: 'About Us' },
    { id: 'culture', labelZh: '媽祖文化與歷史', labelEn: 'Culture & History' },
    { id: 'story', labelZh: '媽祖故事', labelEn: 'Mazu Story' },
    { id: 'gallery', labelZh: '圖庫相冊', labelEn: 'Gallery' },
    { id: 'contact', labelZh: '聯繫我們', labelEn: 'Contact Us' },
  ];

  return (
    <header className="light-header sticky top-0 z-50">
      {/* Top Info Bar */}
      <div className="bg-[#8B0000] text-amber-100 text-xs py-2 px-4 hidden md:flex justify-between items-center">
        <div className="flex items-center gap-6">
          <span className="flex items-center gap-1.5">
            <MapPin className="w-3.5 h-3.5 text-amber-300" />
            <ProtectedContact encoded={ENCODED_CONTACTS.ADDRESS_FULL} />
          </span>
          <span className="flex items-center gap-1.5">
            <Phone className="w-3.5 h-3.5 text-amber-300" />
            <ProtectedContact encoded={ENCODED_CONTACTS.PHONE} type="tel" className="hover:text-amber-200 transition-colors" />
          </span>
        </div>
        <div className="flex items-center gap-2 font-serif text-amber-200">
          <Sparkles className="w-3.5 h-3.5 text-amber-300" />
          <span>弘揚媽祖文化 ‧ 促進和平博愛</span>
        </div>
      </div>

      {/* Main Navigation Bar */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          
          {/* Logo & Title */}
          <div 
            onClick={() => setActiveTab('home')}
            className="flex items-center gap-3 cursor-pointer group"
          >
            <img 
              src="/assets/MAZU.jpg" 
              alt="American Mazu Foundation Logo" 
              className="w-12 h-12 rounded-full border-2 border-amber-600 object-cover shadow-sm group-hover:scale-105 transition-transform"
            />
            <div>
              <h1 className="text-xl sm:text-2xl font-bold text-[#8B0000] tracking-wide leading-tight font-serif">
                美國媽祖基金會
              </h1>
              <p className="text-xs text-gray-600 font-medium tracking-wider uppercase">
                American Mazu Foundation Inc.
              </p>
            </div>
          </div>

          {/* Desktop Nav Links */}
          <nav className="hidden lg:flex items-center gap-1.5">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => setActiveTab(item.id)}
                className={`px-3.5 py-2 rounded-lg transition-all text-center ${
                  activeTab === item.id 
                    ? 'bg-[#8B0000] text-white font-bold shadow-sm' 
                    : 'text-gray-700 hover:text-[#8B0000] hover:bg-gray-100'
                }`}
              >
                <div className="text-sm leading-tight">{item.labelZh}</div>
                <div className="text-[10px] opacity-75 font-mono">{item.labelEn}</div>
              </button>
            ))}
          </nav>

          {/* Quick Contact Button */}
          <div className="hidden lg:block">
            <button 
              onClick={() => setActiveTab('contact')}
              className="btn-red text-xs py-2.5 px-4"
            >
              聯繫我們 Contact
            </button>
          </div>

          {/* Mobile Menu Toggle Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden p-2 text-gray-700 hover:text-[#8B0000]"
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? <X className="w-7 h-7" /> : <Menu className="w-7 h-7" />}
          </button>
        </div>
      </div>

      {/* Mobile Drawer Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden bg-white border-b border-gray-200 px-4 pt-3 pb-6 space-y-2 shadow-lg">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => {
                setActiveTab(item.id);
                setMobileMenuOpen(false);
              }}
              className={`w-full text-left px-4 py-3 rounded-lg flex items-center justify-between transition-colors ${
                activeTab === item.id 
                  ? 'bg-[#8B0000] text-white font-bold' 
                  : 'text-gray-700 hover:bg-gray-100 hover:text-[#8B0000]'
              }`}
            >
              <span className="text-base">{item.labelZh}</span>
              <span className="text-xs opacity-75 font-mono">{item.labelEn}</span>
            </button>
          ))}
          <div className="pt-3 border-t border-gray-200">
            <button 
              onClick={() => {
                setActiveTab('contact');
                setMobileMenuOpen(false);
              }}
              className="btn-red w-full text-center justify-center text-sm py-2.5"
            >
              聯繫我們 (Contact Us)
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
